module.exports = __webpack_public_path__ + "static/img/zhima.275bb01a.png";